import isEmpty from 'lodash/isEmpty';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import HorizontalRule from '@spothero/ui/horizontal-rule';
import Icon from 'common/icon/Icon';
import {
    userUpdate,
    userLogout
} from 'user/user-actions';
import UserUtils from 'user/user-utils';
import {
    userChange,
    updateData
} from '../checkout-actions';
import CheckoutPanel from '../common/CheckoutPanel';
import HeroControls from './hero/HeroControls';
import CheckoutUserAuthentication from './user/CheckoutUserAuthentication';
import UserDetail from './user/UserDetail';

class AccountInformation extends Component {
    static propTypes = {
        isAuthPending: PropTypes.bool,
        user: PropTypes.object.isRequired,
        isMonthly: PropTypes.bool,
        rebookReservationId: PropTypes.number,
        isRebookingReservation: PropTypes.bool,
        purchaseForCustomer: PropTypes.bool,
        purchaseOnBehalfOfCustomer: PropTypes.bool,
        spotId: PropTypes.number,
        selectedRate: PropTypes.object,
        highlight: PropTypes.bool,
        referralSource: PropTypes.string,
        onUserChange: PropTypes.func.isRequired,
        onUserUpdate: PropTypes.func.isRequired,
        onUserLogout: PropTypes.func.isRequired,
        onCheckoutUpdate: PropTypes.func.isRequired
    };
    state = {
        focusGuestLogin: (this.props.user.status !== UserUtils.AUTH_STATE.USER),
        focusUserAuthentication: false,
        heroPurchasing: false
    };

    _onUserChange = data => {
        const {
            isMonthly,
            user,
            onUserChange,
            onUserUpdate,
            onUserLogout
        } = this.props;
        const additionalState = {};

        data.isMonthly = isMonthly;

        if (data.user && !data.userNormalized) {
            data.user = UserUtils.normalize({data: data.user});
        }

        onUserChange(data);

        if (data.user) {
            additionalState.focusGuestLogin = false;
            additionalState.focusUserAuthentication = false;

            onUserUpdate(data.user);
        } else {
            additionalState.focusGuestLogin = (user.status === UserUtils.AUTH_STATE.USER);
            additionalState.focusUserAuthentication = (user.status === UserUtils.AUTH_STATE.GUEST);
            additionalState.heroPurchasing = false;

            onUserLogout();
        }

        this.setState(additionalState);
    }

    _onHeroPurchasing = heroControlsFormData => {
        const {
            user
        } = this.props;
        const {
            user: formUser,
            reservation
        } = heroControlsFormData;
        const {
            purchaseForCustomer,
            purchaseOnBehalfOfCustomer,
            isRebookingReservation
        } = reservation;

        this.setState({
            heroPurchasing: (purchaseForCustomer || purchaseOnBehalfOfCustomer || isRebookingReservation)
        });

        if (formUser) {
            if (purchaseForCustomer) {
                delete formUser.spothero_credit;
            }

            this._onUserChange({
                user: (formUser.isAdmin)
                    ? formUser
                    : UserUtils.normalize({
                        data: formUser,
                        resetToDefaults: true
                    }),
                userNormalized: !isEmpty(formUser.id),
                extraReservationItems: {...reservation}
            });
        } else {
            this._onUserChange({
                user,
                userNormalized: true,
                extraReservationItems: {...reservation}
            });
        }
    }

    _renderPreview() {
        const {
            user
        } = this.props;
        const {
            heroPurchasing
        } = this.state;
        const email = (user.status !== UserUtils.AUTH_STATE.LOGGED_OUT)
            ? user.email
            : null;

        if (email) {
            return (
                <span className="CheckoutPanel-preview-email">
                    {(heroPurchasing) ? 'Purchasing' : 'Checking out'} as {(user.status === UserUtils.AUTH_STATE.GUEST) ? 'guest' : ''} <strong>{email}</strong>
                </span>
            );
        } else {
            return null;
        }
    }

    _renderUserDetail() {
        const {
            user
        } = this.props;

        return (
            <UserDetail
                user={user}
                onUserChange={this._onUserChange}
            />
        );
    }

    submit() {
        const {
            heroPurchasing
        } = this.state;
        const heroControlsFormData = (heroPurchasing) ? this._heroControlsForm.submit() : true;

        return (heroControlsFormData) ? heroControlsFormData : false;
    }

    render() {
        const {
            isAuthPending,
            user,
            rebookReservationId,
            isRebookingReservation,
            purchaseForCustomer,
            purchaseOnBehalfOfCustomer,
            spotId,
            selectedRate,
            highlight,
            referralSource,
            onCheckoutUpdate
        } = this.props;
        const {
            focusGuestLogin,
            focusUserAuthentication,
            heroPurchasing
        } = this.state;
        const isOpen = ((selectedRate && user.status === UserUtils.AUTH_STATE.LOGGED_OUT) || user.isAdmin || heroPurchasing);
        const classes = classNames(
            'CheckoutPanel-account',
            {'CheckoutPanel-completed': (selectedRate && !isOpen)},
            {highlight}
        );

        return (
            <CheckoutPanel
                className={classes}
                title={(
                    <Fragment>
                        {(isOpen)
                            ? <em>1</em>
                            : <em><Icon name="check" /></em>
                        } Account Info
                    </Fragment>
                )}
                additionalTitleMarkup={(selectedRate && (!isOpen || user.isAdmin))
                    ? this._renderUserDetail()
                    : null}
                open={isOpen}
                preview={this._renderPreview()}
            >
                {(user.isAdmin || heroPurchasing) && this._renderPreview()}
                <div className="AccountInformation">
                    {(!heroPurchasing && !user.isAdmin) &&
                        <CheckoutUserAuthentication
                            user={user}
                            referralSource={referralSource}
                            focusGuestLogin={focusGuestLogin}
                            focusUserAuthentication={focusUserAuthentication}
                            onUserChange={this._onUserChange}
                        />
                    }
                    {(user.isAdmin || heroPurchasing) &&
                        <Fragment>
                            <HorizontalRule lineStyle="solid" />
                            <HeroControls
                                ref={node => { this._heroControlsForm = node; }}
                                user={user}
                                isAuthPending={isAuthPending}
                                spotId={spotId}
                                rebookReservationId={rebookReservationId}
                                isRebookingReservation={isRebookingReservation}
                                purchaseForCustomer={purchaseForCustomer}
                                purchaseOnBehalfOfCustomer={purchaseOnBehalfOfCustomer}
                                onHeroControlChange={onCheckoutUpdate}
                                onHeroPurchasing={this._onHeroPurchasing}
                            />
                        </Fragment>
                    }
                </div>
            </CheckoutPanel>
        );
    }
}

const mapStateToProps = state => {
    const {
        checkout: {
            highlightAccountPanel,
            referralSource,
            isRebookingReservation,
            purchaseForCustomer,
            purchaseOnBehalfOfCustomer
        },
        searchRequest: {
            monthly,
            rebook_reservation_id: rebookReservationId
        },
        spot: {
            selected: {
                spotId,
                selectedRate
            }
        },
        user: {
            isPending,
            data: userData
        }
    } = state;

    return {
        isAuthPending: isPending,
        user: userData,
        isMonthly: monthly,
        rebookReservationId,
        isRebookingReservation,
        purchaseForCustomer,
        purchaseOnBehalfOfCustomer,
        spotId,
        selectedRate,
        highlight: highlightAccountPanel,
        referralSource
    };
};

const mapDispatchToProps = {
    onUserUpdate: userUpdate,
    onUserLogout: userLogout,
    onUserChange: userChange,
    onCheckoutUpdate: updateData
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(AccountInformation);
